import { t } from "i18next";
import { useContext, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import { ChannelContext } from "../../../context/channel";
import { DOMAIN_URL } from "../../../settings";
import colors from "../../../theme/colors";
import CrownIcon from "../Icons/CrownIcon";
import LogoEventials from "../Icons/LogoEventials";
import MenuIcon from "../Icons/MenuIcon";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: ${(props) => props.theme.colors.white};
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 87%;
  }
  .header-menu {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 20px;
  }
  .logo {
    display: flex;

    z-index: 1;
    cursor: pointer;
    height: 50px;
    padding-left: 10px;
    padding-right: 10px;
    display: flex;
    align-content: stretch;
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .hry {
    width: 0.8px;
    height: 54px;
    margin: 0 15px;
    background-color: ${(props) => props.theme.colors.border};
  }
  .hrx {
    width: 100vw;
    height: 0.8px;
    margin: 0px;
    background-color: ${(props) => props.theme.colors.border};
  }
  .user-container {
    display: flex;
    align-items: center;
    z-index: 2;
    img {
      height: 32px;
      border: 1px solid ${(props) => props.theme.colors.border};
    }
    .user-dropdown {
      display: flex;
      align-items: center;
      margin-left: 5px;
      span {
        height: 15px;
        width: 80px;
        color: ${(props) => props.theme.colors.label};
        font-size: 11px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .arrow {
        height: 15px;
        width: 20px;
        margin: 0 0 3px 3px;
        content: "";
        display: inline-block;
        vertical-align: middle;
        margin-right: 10px;
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 5px solid ${(props) => props.theme.colors.label};
      }
    }

    .user-container:hover {
      .container-menu {
        visibility: visible;
      }
    }
  }
  @media screen and (max-width: 450px) {
    .header {
      margin: 0 10px;
    }
  }
`;

const ContainerDropdownMenu = styled.div`
  position: absolute;
  top: 0;
  left: 6.5%;
  .container-menu {
    width: 180px;
    height: auto;
    padding: 10px 0;
    margin: 0;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    background-color: white;
  }
  hr {
    border: none;
    border-bottom: solid 1px ${(props) => props.theme.colors.border};
    margin: 8px 0 13px;
  }
  .list-item {
    padding: 3px 15px;
    a {
      color: ${(props) => props.theme.colors.body};
    }
  }
  .list-item span .fonticon-coroa2:before {
  }
  .list-item a:hover {
    color: ${(props) => props.theme.colors.primary};
  }
  @media screen and (min-width: 1800px) {
    left: 130px;
  }
  @media screen and (max-width: 450px) {
    left: 15px;
  }
`;

const ContainerDropdownUser = styled.div`
  z-index: 1;
  position: absolute;
  top: 0;
  right: 6.5%;
  .container-user {
    width: 180px;
    height: auto;
    padding: 10px 0;
    margin: 0;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    background-color: white;
  }
  hr {
    border: none;
    border-bottom: solid 1px ${(props) => props.theme.colors.border};
    margin: 8px 0 13px;
  }
  .list-item {
    padding: 3px 15px;
    a {
      color: ${(props) => props.theme.colors.body};
    }
    a span {
      color: ${(props) => props.theme.colors.success};
      font-size: 17px;
      position: relative;
      top: 3px;
      margin-right: 3px;
    }
  }
  .list-item:hover {
    a {
      color: ${(props) => props.theme.colors.primary};
    }
    a span {
      color: ${(props) => props.theme.colors.primary};
    }
  }
  @media screen and (max-width: 450px) {
    right: 5px;
  }
`;

interface UserData {
  userData?: any
}

const EventialsHeader = ({userData}: UserData) => {
  const {channel, user } = useContext(ChannelContext);
  const [showMenu, setShowMenu] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);

  const history = useHistory();  

  return (
    <>
      <Container>
        <div className="header">
          <div className="header-menu">
            <div style={{ position: "absolute", top: "15px" }} />
            <div
              className="logo"
              onClick={(e) => {
                e.preventDefault();
                history.push("/");
              }}
            >
              <LogoEventials />
            </div>
            <div className="hry"></div>
            <div
              className="logo"
              onMouseEnter={() => setShowMenu(true)}
              onMouseLeave={() => setShowMenu(false)}
            >
              <MenuIcon />
            </div>
          </div>
          <div
            className="user-container"
            onMouseEnter={() => setShowUserMenu(true)}
            onMouseLeave={() => setShowUserMenu(false)}
          >
            <img 
              src={
                userData?.avatar_url || 
                user?.avatar_url || 
                "https://static.eventials.com/static/images/profile_thumb.svg"}
              alt="user" 
            />              
            <div className="user-dropdown">
              <span>{userData?.username || user?.username || t('unknown')}</span>
              <div className="arrow"></div>
            </div>
          </div>
        </div>
        <div className="hrx"></div>
      </Container>
      {showMenu && (
        <ContainerDropdownMenu
          onMouseEnter={() => setShowMenu(true)}
          onMouseLeave={() => setShowMenu(false)}
        >
          <div className="container-menu">
            <div style={{ width: "180px", height: "55px" }} />
            <div className="list-menu">
              <div className="list-item">
                <a href={`https://highlights.eventials.com/`}>{t('menu.explore')}</a>
              </div>
              <div className="list-item">
                <a href={`${DOMAIN_URL}/dashboard/attending/`}>
                {t('menu.mySubscriptions')}
                </a>
              </div>
              <div className="list-item">
                <hr />
              </div>
              <div className="list-item">
                <a
                  href={`/${channel}`}
                  style={{
                    color: colors.primary,
                    textTransform: "uppercase",
                    fontWeight: "600",
                  }}
                >
                  {t('myChannel').toUpperCase()}
                </a>
              </div>
              <div className="list-item">
                <a href={`${DOMAIN_URL}/dashboard/talks/`}>{t('menu.webinars')}</a>
              </div>
              <div className="list-item">
                <a href={`${DOMAIN_URL}/dashboard/events/`}>{t('menu.events',)}</a>
              </div>
              <div className="list-item">
                <a href={`${DOMAIN_URL}/dashboard/courses/`}>{t('menu.courses')}</a>
              </div>
              <div className="list-item">
                <a href={`${DOMAIN_URL}/dashboard/groups/`}>{t('menu.groups')}</a>
              </div>
            </div>
          </div>
        </ContainerDropdownMenu>
      )}
      {showUserMenu && (
        <ContainerDropdownUser
          onMouseEnter={() => setShowUserMenu(true)}
          onMouseLeave={() => setShowUserMenu(false)}
        >
          <div className="container-user">
            <div style={{ width: "180px", height: "55px" }} />
            <div className="list-menu">
              <div className="list-item">
                <a href={`${DOMAIN_URL}/dashboard/`}>{t('menu.user.panel',)}</a>
              </div>
              <div className="list-item">
                <a href={`/${channel}`}>{t('myChannel')}</a>
              </div>
              <div className="list-item">
                <a href={`${DOMAIN_URL}/reports/overview/`}>{t('menu.user.reports')}</a>
              </div>
              <div className="list-item">
                <a href={`${DOMAIN_URL}/settings/`}>{t('menu.user.settings')}</a>
              </div>
              <div
                className="list-item"
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "4px 40px 4px 20px",
                  margin: "5px 0",
                  borderTop: `1px solid ${colors.border}`,
                  borderBottom: `1px solid ${colors.border}`,
                  background: colors.background,
                }}
              >
                <a href={`${DOMAIN_URL}/settings-plan/`}>
                  <div style={{ display: "flex" }}>
                    <CrownIcon style={{ marginBottom: "8px" }} />
                    <strong style={{ marginLeft: "3px" }}>{t('menu.user.myPlan')}</strong>
                  </div>
                </a>
              </div>
              <div className="list-item">
                <a href={`${DOMAIN_URL}/logout/?next=${window.location.href}`}>
                  {t('menu.user.logout')}
                </a>
              </div>
            </div>
          </div>
        </ContainerDropdownUser>
      )}
    </>
  );
};

export default EventialsHeader;
